/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import MondaySlot from "./Slots/MondaySlot";
import { URLS } from "../../../Services/Constant";
import { post } from "../../../Services/ApiHandler";
import { daysList } from "../../StaticData";

const Slot = ({ viewOnly, property_id, room_id, tabsData, setTabsData }) => {
  const [selectedTab, setSelectedTab] = useState("Monday");
  const [slotData, setSlotData] = useState({});

  useEffect(() => {
    viewPrices();
  }, [selectedTab]);

  const viewPrices = async () => {
    const payload = {
      property_id: property_id,
      property_room_id: room_id,
      day: selectedTab,
    };
    const res = await post(`${URLS.PROPERTY_SLOT_SPECIAL_DATES}`, payload);
    console.log("view prices", res);
    if (res?.status === "success") {
      const {
        special_dates,
        days,
        day_prices,
        created_slots,
        not_created_slots,
      } = res?.data;
      setTabsData?.({ slot: days, specialDates: special_dates });
      let created = "";
      let not_created = "";

      let blocked_slots = created_slots?.map((item) => {
        let val = `${item?.timeslot_name}(${item?.timeslot_type?.substring(
          0,
          1
        )})`.replaceAll(" ", "");
        created = `${created} ${"\u00A0"} ${val}`;
        return { value: item?.id, label: item?.timeslot_name, ...item };
      });

      let available_slots = not_created_slots?.map((item) => {
        console.log("slot nam", item);
        let val = `${item?.timeslot_name?.replace(
          " ",
          ""
        )}(${item?.timeslot_type?.substring(0, 1)}) `;
        not_created = `${not_created} ${"\u00A0"} ${val}`;
        return { value: item?.id, label: item?.timeslot_name, ...item };
      });

      setSlotData((prev) => ({
        ...prev,
        [selectedTab]: {
          createdSlots: created,
          balanceSlots: not_created,
          slotsList: day_prices,
          currentSlot: selectedTab,
          availableSlots: available_slots,
          blocked_slots: blocked_slots,
        },
      }));
    }
  };

  return (
    <div className="mt-4 bg-sec1 px-3 py-4 rounded-4">
      <p className="f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 pointer">
        {" "}
        Slots
      </p>
      <div>
        <div className="d-flex ac-js gap-3 mt-2">
          {daysList.map((day, index) => (
            <p
              onClick={() => {
                setSelectedTab(day);
              }}
              className={`${
                selectedTab === day ? "prim-btn" : "slot-act-btn"
              } f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ${
                index !== 0 ? "ms-1" : ""
              } pointer`}
            >
              {" "}
              {`${day} (${tabsData?.slot?.[day] ?? 0})`}
            </p>
          ))}
        </div>
        <MondaySlot
          viewOnly={viewOnly}
          slotData={slotData?.[selectedTab]}
          property_id={property_id}
          room_id={room_id}
          viewPrices={viewPrices}
        />
      </div>
    </div>
  );
};

export default Slot;
